import React from 'react';
import styles from './styles';
import PropTypes from 'prop-types';

const FAQ = ({ block }) => {
  if (!block) return '';
  const { primary } = block;
  const title = primary?.title1;
  const description = primary?.description;
  return (
    <>
      <div className='main-container'>
        <div className='section'>
          <h3 className='title'>{title}</h3>
          <p className='description'>{description}</p>

          <button className='submit' onClick={() => window.location.href = '/pages/faq'}>FAQ</button>
        </div>
      </div>

      <style jsx>{styles}</style>
    </>
  );
};
FAQ.propTypes = {
  block: PropTypes.shape({
    primary: PropTypes.shape({
      header: PropTypes.string,
      imageUrl: PropTypes.object,
    }),
  }),
};

FAQ.defaultProps = {
  block: null,
};

export default FAQ;